import React, { useState, useCallback, useEffect } from 'react';
import SplashAnimation  from '../animations/SplashAnimation';
import Navbar           from '../components/common/Navbar';
import BottomNav        from '../components/common/BottomNav';
import HeroSection      from '../components/home/HeroSection';
import ZodiacWheel      from '../components/home/ZodiacWheel';
import AboutTilak       from '../components/home/AboutTilak';
import MyMessage        from '../components/home/MyMessage';
import StatsBar         from '../components/home/StatsBar';
import ServicesSection  from '../components/home/ServicesSection';
import WhyVTD           from '../components/home/WhyVTD';
import HowItWorks       from '../components/home/HowItWorks';
import Testimonials     from '../components/home/Testimonials';
import DailyHoroscope   from '../components/home/DailyHoroscope';
import WhatsAppBanner   from '../components/home/WhatsAppBanner';
import Reviews          from '../components/home/Reviews';
import Footer           from '../components/common/Footer';
import InstallAppGate   from '../components/common/InstallAppGate';
import './HomePage.css';

const HomePage = () => {
  // Splash animation plays every new session (not every route change).
  // sessionStorage clears when browser tab is closed → animation plays on next open.
  const [showSplash, setShowSplash] = useState(() => {
    try {
      // ?intro=1 forces a replay (admin/testing)
      const params = new URLSearchParams(window.location.search);
      if (params.get('intro') === '1') {
        sessionStorage.removeItem('vtd_splash_played');
        return true;
      }
      return !sessionStorage.getItem('vtd_splash_played');
    } catch (_) {
      return true;
    }
  });

  const handleSplashComplete = useCallback(() => {
    setShowSplash(false);
  }, []);

  useEffect(() => {
    document.body.classList.add('has-bottom-nav');
    return () => {
      document.body.classList.remove('has-bottom-nav');
    };
  }, []);

  return (
    <>
      <InstallAppGate />
      {showSplash && <SplashAnimation onComplete={handleSplashComplete} />}

      <div className={`homepage${!showSplash ? ' homepage--visible' : ''}`}>
        <Navbar />
        <main>
          <HeroSection />
          <ZodiacWheel />
          <AboutTilak />
          <MyMessage />
          <StatsBar />
          <ServicesSection />
          <WhyVTD />
          <HowItWorks />
          <Reviews />
          <Testimonials />
          <DailyHoroscope />
          <WhatsAppBanner />
        </main>
        <Footer />
      </div>

      <BottomNav />
    </>
  );
};

export default HomePage;
